// defs
import { AnalyticsContextValue } from "@swiggy-private/analytics";

// helpers
import { Analytics } from "@payment-client/interfaces/Checkout";
import { getBusinessLine } from "@payment-client/helpers/Misc";

// constants
import { SCREEN_NAME, IMPRESSION_ACTIONS, CLICK_ACTIONS } from "@payment-client/analytics/constants";

export const reviewBillDetailsLandingScreen = (
    screenViewEvent: AnalyticsContextValue["screenViewEvent"],
    context: {
        cartId: string;
        planId: string;
    },
) => {
    screenViewEvent({
        category: SCREEN_NAME.REVIEW_BILL_DETAILS,
        action: IMPRESSION_ACTIONS.IMPRESSION_REVIEW_BILL_DETAILS,
        context: JSON.stringify({
            ...context,
            businessLine: getBusinessLine(),
        }),
    });
};

export const impressionTnCHC = (impressionEvent: AnalyticsContextValue["impressionEvent"]) => {
    impressionEvent({
        category: SCREEN_NAME.REVIEW_BILL_DETAILS,
        action: IMPRESSION_ACTIONS.IMPRESSION_TNC_HC,
    });
};

export const sendEMIWidgetImpressionEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    payload?: Analytics,
) => {
    if (!payload) {
        return;
    }

    const { context, impressionObjectName } = payload;

    impressionEvent({
        category: SCREEN_NAME.REVIEW_BILL_DETAILS,
        action: impressionObjectName,
        context: JSON.stringify({ context }),
    });
};

export const impressionEMIDetailsHC = (impressionEvent: AnalyticsContextValue["impressionEvent"]) => {
    impressionEvent({
        category: SCREEN_NAME.REVIEW_BILL_DETAILS,
        action: IMPRESSION_ACTIONS.IMPRESSION_EMI_DETAIL_HC,
    });
};
export const clickTnC = (clickEvent: AnalyticsContextValue["clickEvent"]) => {
    clickEvent({
        category: SCREEN_NAME.REVIEW_BILL_DETAILS,
        action: CLICK_ACTIONS.CLICK_EMI_TNC_REVIEW_BILL_DETAILS,
    });
};

export const clickEmiDetails = (clickEvent: AnalyticsContextValue["clickEvent"]) => {
    clickEvent({
        category: SCREEN_NAME.REVIEW_BILL_DETAILS,
        action: CLICK_ACTIONS.CLICK_EMI_DETAIL_REVIEW_BILL_DETAILS,
    });
};

export const clickProceedToPay = (clickEvent: AnalyticsContextValue["clickEvent"]) => {
    clickEvent({
        category: SCREEN_NAME.REVIEW_BILL_DETAILS,
        action: CLICK_ACTIONS.CLICK_PAY_REVIEW_BILL_DETAILS,
    });
};

export const impressionErrorScreen = (impressionEvent: AnalyticsContextValue["impressionEvent"]) => {
    impressionEvent({
        category: SCREEN_NAME.REVIEW_BILL_DETAILS,
        action: IMPRESSION_ACTIONS.IMPRESSION_REVIEW_BILL_DETAILS_FAIL,
    });
};
